import React from "react";
import TitleField from "./components/TitleField";
import TextInputField from "./components/TextInputField";
import SingleChoiceField from "./components/SingleChoiceField";
import MultipleChoiceField from "./components/MultipleChoiceField";
import TableField from "./components/TableField";

const SurveyWealthField = ({
  question,
  questionIdx,
  control,
  index,
  hasAnswer,
}) => {
  if (question.type === "TITLE") {
    return (
      <TitleField title={question.title} description={question?.description} />
    );
  }
  if (question.type === "QUESTION" && question.subType === "TEXT_QUESTION") {
    return (
      <TextInputField
        control={control}
        require={question.isRequire}
        question={question}
        questionIdx={questionIdx}
        name={`${question.elementId}`}
        answerId={question.children[0]?.elementId}
        disabled={hasAnswer}
      />
    );
  }
  if (question.type === "QUESTION" && question.subType === "CHOICE_QUESTION") {
    if (question.isMultiple) {
      return (
        <MultipleChoiceField
          control={control}
          name={`${question.elementId}`}
          question={question}
          questionIdx={questionIdx}
          listAnswer={question.children}
          disabled={hasAnswer}
        />
      );
    } else {
      return (
        <SingleChoiceField
          control={control}
          name={`${question.elementId}`}
          question={question}
          questionIdx={questionIdx}
          listAnswer={question.children}
          disabled={hasAnswer}
        />
      );
    }
  }
  if (question.type === "QUESTION" && question.subType === "TABLE_QUESTION") {
    return (
      <TableField
        control={control}
        name={`${question.elementId}`}
        question={question}
        questionIdx={questionIdx}
        listAnswer={question.children}
        disabled={hasAnswer}
      />
    );
  }

  return <></>;
};

export default SurveyWealthField;
